import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
//import { getFirebaseBackend } from '../../authUtils';
import { User } from '../models/auth.models';

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    user!: User;
  currentUserValue: any;
  url = environment.apiUrl + '/api/User'

  constructor(private http: HttpClient) {
}

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        //return getFirebaseBackend()!.registerUser(email, password).then((response: any) => {
        //    const user = response;
        //    return user;
        //});
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        //return getFirebaseBackend()!.loginUser(email, password).then((response: any) => {
        //    const user = response;
        //    return user;
        //});
    }

    /**
     * Returns the current user
     */
    public currentUser(): any {
        //return getFirebaseBackend()!.getAuthenticatedUser();
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        //return getFirebaseBackend()!.logout();
    }

    /**
     * Reset password
     * @param email email
     */
  loginuser(loginform) {
    debugger
    return this.http.post(this.url + '/GetLogin', loginform);
  }
  getLoginData(UserName) {
    return this.http.get(this.url + '/GetLogindata' + '/' + UserName)
  }
    //resetPassword(email: string) {
    //    return getFirebaseBackend()!.forgetPassword(email).then((response: any) => {
    //        const message = response.data;
    //        return message;
    //    });
    //}

}

